import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Carousel from "../views/Carousel.vue";
import News from "../views/News.vue";
import GaugesView from "../views/GaugesView.vue";
import AboutPollingData from "../views/AboutPollingData.vue";
import AboutApproval from "../views/AboutApproval.vue";
import AboutElectoralCollege from "../views/AboutElectoralCollege.vue";
import AboutPopularVote from "../views/AboutPopularVote.vue";
import AboutSenateControl from "../views/AboutSenateControl.vue";
import AboutBettingMarkets from "../views/AboutBettingMarkets.vue";
import AboutGenericBallot from "../views/AboutGenericBallot.vue";
import Feedback from "../views/Feedback.vue";


import TomTest from "../views/TomTest.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    component: About
    //TODO: this was failing to compile:
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.

    //component: () =>
    // import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/carousel",
    name: "Carousel",
    component: Carousel
  },
  {
    path: "/news",
    name: "News",
    component: News
  },
  {
    path: "/gauges",
    name: "Gauges",
    component: GaugesView
  },
  {
    path: "/about_polling_data",
    name: "AboutPollingData",
    component: AboutPollingData
  },
  {
    path: "/electoral_college",
    name: "AboutElectoralCollege",
    component: AboutElectoralCollege
  },
  {
    path: "/approval_chart",
    name: "AboutApproval",
    component: AboutApproval
  },
  {
    path: "/popular_vote_gauge",
    name: "AboutPopularVote",
    component: AboutPopularVote
  },
  {
    path: "/senate_control_gauge",
    name: "AboutSenateControl",
    component: AboutSenateControl
  },
  {
    path: "/generic_ballot_gauge",
    name: "AboutGenericBallot",
    component: AboutGenericBallot
  },
  {
    path: "/betting_markets",
    name: "AboutBettingMarkets",
    component: AboutBettingMarkets
  },
  {
    path: "/feedback",
    name: "Feedback",
    component: Feedback
  },
  {
    path: "/538_model",
    name: "538_Model",
    beforeEnter() {
      window.open(
        'https://fivethirtyeight.com/features/how-fivethirtyeights-2020-presidential-forecast-works-and-whats-different-because-of-covid-19',
        '_blank'
      );
      // same window: location.href = 'https://fivethirtyeight.com/features/how-fivethirtyeights-2020-presidential-forecast-works-and-whats-different-because-of-covid-19'
    }
  },
  {
    path: "/tomv",
    name: "TomTest",
    component: TomTest
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
